import { Component, Output, EventEmitter } from '@angular/core';
import { RoutesUtil } from '@shared-features/utils';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OTPInputComponent {
  readonly RoutesUtil = RoutesUtil;
  
  otp: number;
  @Output() send = new EventEmitter();
  
  onOtpChange(event){
    this.otp = event;
  }
}
